import { useRef, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePage } from "../actions/navigationActions";

const HoverDrawerPopout = () => {
  const dispatch = useDispatch();
  const currentThumb = useRef(null);

  const { openThumbnailDrawer, thumbnails, currentPage } = useSelector(
    (state) => ({
      ...state.navigationReducer,
    })
  );

  const handleThumbnailClick = (pageNumber) => {
    if (currentPage === pageNumber) return;
    dispatch(changePage(pageNumber, null));
  };

  const requestImageFile = require.context(
    "../SlideNavigator/thumbnails",
    true,
    /.jpeg$/
  );

  const createThumbnail = (fileNumber) => {
    const selected = fileNumber === currentPage;
    if (selected)
      return (
        <div
          key={fileNumber}
          ref={currentThumb}
          className="thumbnail-container selected-thumbnail"
          onClick={() => handleThumbnailClick(fileNumber)}
        >
          <span className="thumbnail-number">{fileNumber}</span>
          <img
            src={requestImageFile(`./${fileNumber}.jpeg`).default}
            alt={fileNumber}
            className="thumbnail-image"
          />
        </div>
      );
    return (
      <div
        key={fileNumber}
        className="thumbnail-container"
        onClick={() => handleThumbnailClick(fileNumber)}
      >
        <span className="thumbnail-number">{fileNumber}</span>
        <img
          src={requestImageFile(`./${fileNumber}.jpeg`).default}
          alt={fileNumber}
          className="thumbnail-image"
        />
      </div>
    );
  };

  const generateThumbnails = () => {
    return thumbnails.map(createThumbnail);
  };

  const handleMouseEnter = () => {
    currentThumb.current.scrollIntoView();
  };

  return (
    <div
      className={`thumbnail-popout ${openThumbnailDrawer ? "popped-out" : ""}`}
      onMouseEnter={handleMouseEnter}
    >
      {generateThumbnails()}
    </div>
  );
};

export default HoverDrawerPopout;
